export default "__VITE_ASSET__261280dc__"